/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import { Modal } from 'antd-mobile'
import { ModalBg } from '@styles/base.style'
import { Button, CloseBtn } from '@styles/button.style'
import { isMobile } from 'react-device-detect'
import { CompanyPickImgWrap } from '../index.style'

interface CompanyPickImagePopupProps {
  visible?: boolean
  setVisible?: (arg: boolean) => void
  imgSrc?: string
}

const CompanyPickImagePopup: React.FC<CompanyPickImagePopupProps> = (props: CompanyPickImagePopupProps) => {

  const { visible, setVisible, imgSrc } = props

  const onCloseModal = () => {
    setVisible(false)
  }

  return (
    <Modal
      transparent
      visible={visible}
      maskClosable={false}
      onClose={onCloseModal}
      className="event"
    >
      <CompanyPickImgWrap className={!isMobile && 'pc'}>
        <div className="img-box">
          <img src={imgSrc} alt="프리미엄 분석가 경기분석 이미지"/>
        </div>
        <Button className="close-btn position-top" css={CloseBtn} onClick={onCloseModal}>
          <span className="close-txt">닫기</span>
        </Button>
        <ModalBg onClick={onCloseModal}/>
      </CompanyPickImgWrap>
    </Modal>
  )
}
export default observer(CompanyPickImagePopup)
